/* tslint:disable */
/* eslint-disable */
/**
 * 80s Conservation Club REST API
 * 80s Conservation Club REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: graham@matthewsapps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TopicOptOut } from './TopicOptOut';
import {
    TopicOptOutFromJSON,
    TopicOptOutFromJSONTyped,
    TopicOptOutToJSON,
} from './TopicOptOut';

/**
 * 
 * @export
 * @interface CreateEmailTopicOptOut200Response
 */
export interface CreateEmailTopicOptOut200Response {
    /**
     * 
     * @type {TopicOptOut}
     * @memberof CreateEmailTopicOptOut200Response
     */
    data: TopicOptOut;
}

/**
 * Check if a given object implements the CreateEmailTopicOptOut200Response interface.
 */
export function instanceOfCreateEmailTopicOptOut200Response(value: object): value is CreateEmailTopicOptOut200Response {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function CreateEmailTopicOptOut200ResponseFromJSON(json: any): CreateEmailTopicOptOut200Response {
    return CreateEmailTopicOptOut200ResponseFromJSONTyped(json, false);
}

export function CreateEmailTopicOptOut200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateEmailTopicOptOut200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': TopicOptOutFromJSON(json['data']),
    };
}

export function CreateEmailTopicOptOut200ResponseToJSON(value?: CreateEmailTopicOptOut200Response | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'data': TopicOptOutToJSON(value['data']),
    };
}

